import {APIError} from 'data/errors';
import {HttpStatusCode} from 'data/protocols/http/http-client';
import {APIErrorsMessage} from 'presentation/pages';

const isNotAllowedForSpecialtyError = (error: unknown) =>
	error instanceof APIError &&
	error.statusCode === HttpStatusCode.unprocessable &&
	error?.message === APIErrorsMessage.NOT_ALLOWED_FOR_SPECIALTY;

export {isNotAllowedForSpecialtyError};
